import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EyeOff } from 'lucide-react';
import { request } from '../../api/client';
import type { User } from '../../api/types';
import { Modal } from '../../components/Modal';

export function HideProjectDialog({ project, onClose, onHidden }: { project: { id: number; title: string }; onClose: () => void; onHidden: () => void }) {
  const cache = useQueryClient();
  const hide = useMutation({
    mutationFn: () => request<{ id: number; discarded: true }>(`/api/projects/${project.id}/discard`, { method: 'POST', body: { discarded: true } }),
    onSuccess: async () => {
      await cache.cancelQueries({ queryKey: ['current-user'] });
      cache.setQueryData<User | null>(['current-user'], current => current ? { ...current, projects: current.projects?.filter(item => item.id !== project.id) } : current);
      onHidden();
      void cache.invalidateQueries({ predicate: query => ['current-user', 'project-cards', 'access-projects', 'assets', 'regulation-assets', 'dashboard'].includes(String(query.queryKey[0])) });
    },
  });
  return <Modal title="Скрыть проект" size="small" className="sc-dialog" onClose={() => { if (!hide.isPending) onClose(); }}>
    <form onSubmit={event => { event.preventDefault(); if (!hide.isPending) hide.mutate(); }}>
      <p>Скрыть проект «{project.title}»?</p>
      <p className="sc-edit-note">Он исчезнет из списка у всех пользователей. Ассеты, история и файлы сохранятся. Вернуть проект можно через администрирование.</p>
      {hide.error && <p className="sc-error" role="alert">{hide.error.message}</p>}
      <footer><button autoFocus type="button" disabled={hide.isPending} onClick={onClose}>Отмена</button><button className="sc-primary" disabled={hide.isPending}><EyeOff size={17}/>{hide.isPending ? 'Скрываем…' : 'Скрыть проект'}</button></footer>
    </form>
  </Modal>;
}
